import DialogContent from '@material-ui/core/DialogContent';

/** @deprecated  Exporting the DialogContent component from the material-ui library. */
export default DialogContent;
